import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import { Link } from 'react-router-dom';
import TablaSincronizaciones from '../utils/TablaSincronizaciones';

const SincronizacionesLayer = () => {
    return (
        <>
           <TablaSincronizaciones />            
        </>

    );
};

export default SincronizacionesLayer;